import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    zIndex: 1,
    textAlign: 'center',
  },
  leftAlign: {
    textAlign: 'left',
  },
  title: {
    fontSize: 48,
    lineHeight: '48px',
    fontFamily: 'Bebas, Lato',
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: theme.spacing(1),
  },
  body: {
    fontSize: 20,
    maxWidth: 300,
    lineHeight: '22px',
  },
})

const PageNotFoundText = ({ classes, leftAlign }) => (
  <div className={classNames(classes.root, leftAlign && classes.leftAlign)}>
    <Typography className={classes.title}>PAGE NOT FOUND</Typography>
      <Typography className={classes.body}>
          We can't seem to track down the page you are looking for
      </Typography>
  </div>
)

PageNotFoundText.propTypes = {
  classes: PropTypes.object,
  leftAlign: PropTypes.bool,
}

export default withStyles(styles)(PageNotFoundText)



// WEBPACK FOOTER //
// ./src/components/atoms/PageNotFoundText.js